export enum FileType {
    Unknown = 0,
    Image = 1,
    Audio = 2,
    Movie = 3,
    Pdf = 4,
    MsWord = 5,
    Excel = 6,
    PowerPoint = 7,
    Document = 8,
    Compressed = 9,
    StyleSheet = 10,
    JavaScript = 11,
    ImageWithoutPreview = 12,
    MovieNotPlayable = 13,
    PdfNoPreview = 14,
}
